import { Component, AfterViewInit, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements AfterViewInit, OnInit {
  sections = {};
  isMobileMenuOpen = false;

  constructor(private router: Router) { }

  async ngOnInit() {
    // Aplicar estilos de navegación
    this.applyNavigationStyles();
    
    // Configurar scroll de navbar
    this.setupNavbarScroll();
  }

  private applyNavigationStyles() {
    const homeLink = document.querySelector('a[data="id_home"]');
    if (homeLink) {
      if (this.router.url === "/") {
        homeLink.setAttribute('style', 'color:#1bbc9d!important');
      } else if (this.router.url === "/index9") {
        homeLink.setAttribute('style', 'color:#ffffff!important');
      } else {
        homeLink.setAttribute('style', 'color:#000000!important');
      }
    }
  }

  private setupNavbarScroll() {
    const navbar1 = document.getElementById("navbar1");
    if (navbar1) {
      navbar1.style.backgroundColor = "#272a33";
      navbar1.style.padding = "10px";

      window.onscroll = () => {
        if (document.body.scrollTop > 40 || document.documentElement.scrollTop > 40) {
          navbar1.style.backgroundColor = "#272a33";
          navbar1.style.padding = "10px";
        } else {
          navbar1.style.backgroundColor = "#272a33";
          navbar1.style.padding = "10px";
        }
      };
    }
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  toggleMenu() {
    const navbarCollapse = document.getElementById('navbarCollapse');
    const menuButton = document.getElementById('menu_button');
    
    if (navbarCollapse) {
      navbarCollapse.classList.toggle('show');
    }
    if (menuButton) {
      menuButton.classList.toggle('collapsed');
    }
  }

  ngAfterViewInit() {
    // Configurar scroll nativo
    setTimeout(() => {
      this.setupNativeScroll();
    }, 200);
  }

  private setupNativeScroll() {
    const sections: NodeListOf<Element> = document.querySelectorAll(".section");
    
    sections.forEach((element) => {
      if (element.id) {
        const htmlElement = element as HTMLElement;
        this.sections[element.id] = htmlElement.offsetTop;
      }
    });

    // Usar scroll nativo del navegador
    window.addEventListener('scroll', () => {
      this.handleScrollSpy();
    });
  }

  private handleScrollSpy() {
    const scrollPosition = document.documentElement.scrollTop;
    
    for (const menu in this.sections) {
      if (this.sections[menu] <= scrollPosition && menu && menu !== "testi") {
        this.updateMenuStyles(menu);
      }
    }
  }

  private updateMenuStyles(menu: string) {
    const menuLink = document.querySelector(`a[data="id_${menu}"]`);
    if (!menuLink) return;

    if (this.router.url === "/") {
      this.clearMenu('#393f4f');
      menuLink.setAttribute('style', 'color:#1bbc9d!important');
    } else if (this.router.url === "/index9") {
      this.clearMenu('#ffffff99');
      menuLink.setAttribute('style', 'color:#ffffff!important');
    } else {
      this.clearMenu('#ffffff99');
      menuLink.setAttribute('style', 'color:#1bbc9d !important');
    }
  }

  private clearMenu(color: string) {
    const menuSelectors = [
      'a[data="id_home"]',
      'a[data="id_services"]',
      'a[data="id_features"]',
      'a[data="id_pricing"]',
      'a[data="id_about"]',
      'a[data="id_contact"]'
    ];

    menuSelectors.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) {
        element.setAttribute('style', `color:${color}!important`);
      }
    });
  }
}